module.exports = "/images/vendor/flag-icon-css/flags/4x3/gn.svg?36a3e9a3dd82736bfcf23f28bb3ebc10";